export const SET_CURRENT_TAB = 'client/modules/stories/actions/SET_CURRENT_TAB';

export function setCurrentTab(currentTab) {
  return { type: SET_CURRENT_TAB, currentTab };
}

export default setCurrentTab;
